const stripHtml = (html: string) => {
  const REGEX = /(<([^>]+)>)/gi
  return html.replace(REGEX, '')
}

export default stripHtml
